import React from 'react';
import { connect } from 'react-redux';
import { Route as ReactRoute, RouteProps } from 'react-router-dom';
import { goToLogin } from '@xgimi-private/user-center';
import CircularProgress from 'xgimi-ui/mui/material/CircularProgress';
import { deleteObjectKeys } from 'xgimi-utils/object';
import App from '@xgimi-private/xgimi-app-bridge';
import { version } from '../../appUtils/version';
import { versionCompare } from '../../appUtils/versionCompare';

import StoreComponent, { mapStateToProps } from '../Store';

import s from './.module.scss';

interface Props extends RouteProps {
  // 是否依赖用户信息 (必须登录)
  isLogin?: boolean;
  // APP版本号
  appVersion?: string;
}

interface State {}

/**
 * 路由
 */
class Route extends StoreComponent<Props, State> {
  static defaultProps = {
    isLogin: false,
  };

  state: State = {};

  constructor(props: Props) {
    super(props, { languageKey: 'route' });
  }

  private Loading = () => (
    <div className={s.loading}><CircularProgress disableShrink={true} size={28}/></div>
  );

  render(): React.ReactNode {
    let component: React.ComponentType<any> | undefined = this.props.component;

    // 如果是APP并且传了APP版本号时判断下当前APP版本低于版本号时就跳转到下载APP页面
    if (App.isSuperApp() && this.props.appVersion) {
      const curV = version(window.navigator.userAgent);
      if (versionCompare(curV, this.props.appVersion) === false) {
        window.location.href = '/upload';
      }
    }

    // 登录验证
    if (this.props.isLogin && !this.storeState.userCenter.userInfo) {
      if (this.storeState.userCenter.isGettingUserInfo) {
        component = this.Loading;
      }
      // 跳转登录
      else {
        goToLogin();
        component = undefined;
      }
    }

    return (
      <ReactRoute
        {...deleteObjectKeys(this.props, ['isLogin'])}
        component={component}
      />
    );
  }
}

export default connect(mapStateToProps)(Route);
